
import {epos2Axios, eposAxios} from "@/interceptors/axios";
import VueCookies from "vue-cookies";
import AssembleDataService from "@/services/AssembleDataService";

const barcodePatterns = {
    'rfid'      : /^([A-Fa-f0-9-]{24})$/,
    'garment'   : /^G(\d+)$/,
    'customer'  : /^C(\d+)$/,
    'item'      : /^I(\d+)$/,
    'order'     : /^O(\d{3,})$/,
    'ticket_order' : /^ST(\d{9,})\/(d{2})$/, // Valid for types 1: ST000787163/03
    'ticket'    : /^ST(\d{9,})\/(\w{8,})$/, // Valid for types 2: ST000787166/ecc3d838
    'rail'      : /^R(\d{4})$/,             // Dispatch Rails, in the loading bay
    'qc-status' : /^QCS(\d{1,})$/,
    'qc-rail'   : /^QCR(\d{1,})$/,
    'pu-rail'   : /^PUR(\d{4})$/,
    'command'   : /^LRCMD:(.*)$/,
    'rfid-hex'  : /^([0-9A-Fa-f]{24})$/
};
class BarcodeService {

    /**
     * Takes a barcode string, validates it and breaks it apart into type of barcode and numerical id
     * @param barcode
     * @returns {{id, type: string, barcode}}
     */
    getBarcodeDetails(barcode) {
        let barcode_type;
        let barcode_id;
        console.log("barcodePatterns", barcodePatterns)
        for( let type in barcodePatterns ) {
            let matchResult = barcode.match( barcodePatterns[type] );
            if( matchResult ) {
                barcode_type  = type;
                barcode_id    = matchResult[1] || barcode;
                break;
            }
        }

        return { type: barcode_type, id: barcode_id, barcode: barcode };
    }

    /**
     * Record a barcode scan in the database log, no matter if successful or not.
     * The method takes the barcode details object returned by the getBarcodeDetails method
     * @param barcodeDetails
     * @param action
     */
    recordBarcode(barcodeDetails, action){
        if (barcodeDetails.id !== undefined) {
            console.log(barcodeDetails)
            let workstation_id = VueCookies.get('epos2_workstationid');
            AssembleDataService.recordBarcodeScan(barcodeDetails.barcode_id, barcodeDetails.type, action, workstation_id)
                .catch(error => {
                    console.error('An error occurred logging the barcode', error);
                });
        }
    }

    getBarcodeStatusMessage() {

        if( this.barcodeDisabled )
            return 'Barcode Scanner Disabled';

        if( this.barcodeProcessing )
            return 'Processing...';

        if( this.barcodeStatusText )
            return this.barcodeStatusText;

        return this.barcodeFocussed ? 'Ready to scan' : 'Click here to start scanning' ;
    }

    /**
     * Log a barcode scan in the database using EPOS2 endpoint. The EP will automatically look up
     * workstation id and user id from the active session
     *
     * @param barcode
     * @param action
     */
    logBarcode(barcode, action){
        try {
            const data = {
                barcode: barcode,
                action: action,
            };
            const response = epos2Axios.post('/api/barcodescans', data);
        } catch (error) {
            console.error(`Error: ${error.response.status}`);
        }
    }

    /**
     * Get item /garment order details based on barcode
     *
     * @param barcode
     * @param type
     */
    getByBarcode(barcode, type){
        if (type == 'item') {
            try {
                return epos2Axios.get('/api/garmentorder/'+type+'/'+barcode);
            } catch (error) {
                console.error(`Error: ${error.response.status}`);
            }
        }

    }
}

export default new BarcodeService()
